import React from 'react';
import { StyleSheet, css } from 'aphrodite';
import Grid from '@material-ui/core/Grid';
import { StatusTile } from './StatusTile';
import { CommonStyles } from '../styles/Styles';
import { Helper } from '../common/helpers/Helper';

export function Stats(props) {

  const colWidth = 4

  return (
    <Grid item>
      <div className={css(Styles.statusHolder)}>
        {props.items.map((item, index) => {
          return (
            <Grid key={index} lg={props.lg || colWidth} xs={12} sm={12} md={props.md || colWidth} item className={css([Styles.statsBody, props.statsBody])}>
              <div className={css(Styles.statsTitle)}>{item.title}</div>
              <div className={css(Styles.statsBodyContainer)}>
                <div className={css(Styles.statsValueBody)}>
                  {item.icon && (
                    <div className={css(Styles.statsImageHolder)}>
                      <i className='material-icons-outlined' style={{ fontSize: 18, padding: 5 }}>{item.icon}</i>
                    </div>
                  )}
                  {item.image && (
                    <div className={css(Styles.statsImageHolder)}>
                      <img className={css(Styles.statsImage)} src={item.image} />
                    </div>
                  )}
                  <div className={css(Styles.statsValue)}>{item.value}</div>
                </div>
                {item.showDetails && (
                  <div className={css(Styles.statsFooter)}>
                    <button
                      type='button'
                      className={css(Styles.showDetailsButton)}
                      onClick={item.showDetails.onClick}
                    >
                      {item.showDetails.label || Helper.getString('showDetails')}
                    </button>
                  </div>
                )}
              </div>
            </Grid>
          )
        })}
      </div>
    </Grid>
  )
}

const Styles = StyleSheet.create({
  statsImage: {
    width: 34,
    height: 34
  },
  statusHolder: {
    backgroundColor: '#FFFFFF',
    borderRadius: 16,
    display: 'flex',
    flexDirection: 'row',
    flexWrap: 'wrap',
    overflow:'hidden'
  },
  statsBody: {
    minWidth: '262px',
    flexDirection: 'row',
    justifyContent: 'flex-start',
    textAlign: 'left',
    padding: '22px 26px',
    position: 'relative',

    ':first-child': {
      borderLeft: 'none',
      borderRadius: '16px 0px 0px 16px'
    },
    ':last-child': {
      marginLeft: 0,
      borderRadius: '0px 16px 16px 0px',
      '::before': {
        display: 'none'
      }
    },
    '::before': {
      content: '""',
      width: '1px',
      height: '50%',
      backgroundColor: '#D7D7D7',
      position: 'absolute',
      right: 8,
      top: '25%',
      '@media (max-width: 1024px)': {
        display: 'none'
      }
    },
    '::after': {
      content: '"" !important',
      backgroundColor: 'rgb(215, 215, 215) !important',
      position: 'absolute !important',
      bottom: -2,
      width: '80%',
      height: '1px'
    } ,
    ':nth-child(3)': {
      '::before': {
        display: 'none'
      }
    },
    ':nth-child(6)': {
      '::before': {
        display: 'none'
      }
    },
    ':nth-child(9)': {
      '::before': {
        display: 'none'
      }
    }
  },
  statsTitle: {
    fontSize: 16,
    color: '#121212',
    marginBottom: 10
  },
  statsValueBody: {
    display: 'flex'
  },
  statsValue: {
    fontSize: 28,
    color: '#121212',
  },
  statsBodyContainer:{
    display: 'flex',
    justifyContent: 'space-between'
  },
  statsFooter: {
    display: 'flex',
    justifyContent: 'flex-end',
    marginTop: 12
  },
  showDetailsButton: {
    border: 'none',
    background: 'transparent',
    padding: 0,
    cursor: 'pointer',
    color: '#185ADB',
    fontSize: 13,
    fontWeight: 600
  },
  statsImageHolder: {
    marginRight: 10
  }
})


// WEBPACK FOOTER //
// ./src/components/Stats.js